import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function CaContentReducer(state = initialState.caContent, action: any) {
  switch (action.type) {
    case types.SAVE_CACONTENT_SUCCESS:
      return action.caContent;
    default:
      return state;
  }
}
